import apiClient from './apiClient';

export const getOemScanListApi = (params) => {
  return apiClient.get('/partners/almata-partners/oem-myscan-list', { params });
};
export const getOemNamesByAlmataApi = (almataId) => {
  return apiClient.get(`/partners/almata-partners/oem-partners/names/${almataId}`);
};